import Path from '../../../services/paths'
import utils from '../../common/utils'
import OutletAction from '../../prat_actions/gt/outletAction'
import CustomToast from '../../../util-functions/customToast.jsx'

export default class GeoMiddleware {
    static get_outletProgram(){
        return dispatch => {
            dispatch(OutletAction.outletProgram_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_OUTLET_PROGRAM , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(OutletAction.outletProgram_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.outletProgram_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.outletProgram_Failed(err.message))

            })
        }
    };

    // Location Type

    static get_LocationType(){
        return dispatch => {
            dispatch(OutletAction.locationType_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_LOCATION_TYPE , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(OutletAction.locationType_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.locationType_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.locationType_Failed(err.message))

            })
        }
    };

    //  Tier

    static get_tier(){
        return dispatch => {
            dispatch(OutletAction.tier_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_TIER , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(OutletAction.tier_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.tier_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.tier_Failed(err.message))

            })
        };
    };

    // perfect village

     static get_perfectVillage(){
        return dispatch => {
            dispatch(OutletAction.perfectVillage_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_PERFECT_VILLAGE , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(OutletAction.perfectVillage_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.perfectVillage_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.perfectVillage_Failed(err.message))

            })
        }
    };

    // Channel Tts

    
    static get_channelTts(){
        return dispatch => {
            dispatch(OutletAction.channelTts_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_CHANNEL_TTS , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(OutletAction.channelTts_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.channelTts_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.channelTts_Failed(err.message))

            })
        }
    };

    // Chain Outleta

    
    static get_chainOutlets(){
        return dispatch => {
            dispatch(OutletAction.chainOutlets_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_CHAIN_OUTLETS , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(OutletAction.chainOutlets_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.chainOutlets_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.chainOutlets_Failed(err.message))

            })
        }
    };

    // Perfect Store
    
    static get_perfectStore(){
        return dispatch => {
            dispatch(OutletAction.perfectStore_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_PERFECT_STORE , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(OutletAction.perfectStore_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.perfectStore_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.perfectStore_Failed(err.message))

            })
        }
    };

    // Perfect Store Compliance

    static get_perfectStoreCompliance(){
        return dispatch => {
            dispatch(OutletAction.perfectStoreCompliane_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_PERFECT_STORE_COMPLIANCE, {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(OutletAction.perfectStoreCompliane_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.perfectStoreCompliane_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.perfectStoreCompliane_Failed(err.message))

            })
        }
    };

    // Outlet Classification

    static get_outletClassification(){
        return dispatch => {
            dispatch(OutletAction.outletClassification_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_OUTLET_CLASSIFICATION , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(OutletAction.outletClassification_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.outletClassification_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.outletClassification_Failed(err.message))

            })
        }
    };

    // Range

    static get_range(){
        return dispatch => {
            dispatch(OutletAction.range_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_RANGE , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(OutletAction.range_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.range_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.range_Failed(err.message))

            })
        }
    };

    // Point Of Consumption

    static get_pointOfConsumption(){
        return dispatch => {
            dispatch(OutletAction.pointOfConsumption_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_POINT_OF_CONSUMPTION , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(OutletAction.pointOfConsumption_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.pointOfConsumption_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.pointOfConsumption_Failed(err.message))

            })
        }
    };

    // Loyality Program

    static get_loyalityProgram(){
        return dispatch => {
            dispatch(OutletAction.loyalityProgram_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_LOYALITY_PROGRAM , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(OutletAction.loyalityProgram_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.loyalityProgram_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.loyalityProgram_Failed(err.message))

            })
        }
    };

    // Customer Attribute

    static get_customerAttribute(){
        return dispatch => {
            dispatch(OutletAction.customerAttribute_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_CUSTOMER_ATTRIBUTE , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(OutletAction.customerAttribute_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.customerAttribute_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.customerAttribute_Failed(err.message))

            })
        }
    };

    // OUTLET SUMMARY

    static get_outletSummary(
        geoData,
        channelData,
        channelName,
        selectedOutletProgram,
        selectedLocationType,
        selectedTier,
        selectedPerfectVillage,
        selectedChannelTts,
        selectedChainOutlets,
        selectedPerfectStore,
        selectedPerfectStoreCompliance,
        selectedOutleClassification,
        selectedRange,
        selectedPointOfConsumption,
        selectedLoyalityProgram,
        selectedCustomerAttribute,
        excludedOutletFromSummary
    ){
        return dispatch => {
            dispatch(OutletAction.outletSummary_Request());
            utils.get_token()
            .then(token => {
                fetch(
                    Path.GET_OUTLET_SUMMARY,
                    {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        'distributors':geoData?geoData:[],
                        'channel_level':channelName?channelName:null,
                        'channels':channelData?channelData:[],
                        'outlet_programs':selectedOutletProgram?selectedOutletProgram:[],
                        'location_types':selectedLocationType?selectedLocationType:[],
                        'tiers':selectedTier?selectedTier:[],
                        'perfect_villages':selectedPerfectVillage?selectedPerfectVillage:[],
                        'perfect_stores':selectedPerfectStore?selectedPerfectStore:[],
                        'perfect_store_compliances':selectedPerfectStoreCompliance?selectedPerfectStoreCompliance:[],
                        'outlet_classifications':selectedOutleClassification?selectedOutleClassification:[],
                        'outlet_ranges':selectedRange?selectedRange:[],
                        'point_of_consumptions':selectedPointOfConsumption?selectedPointOfConsumption:[],
                        'loyalty_programs':selectedLoyalityProgram?selectedLoyalityProgram:[],
                        'chain_outlets':selectedChainOutlets?selectedChainOutlets:[],
                        'customer_attributes_12':selectedCustomerAttribute?selectedCustomerAttribute:[],
                        'channels_tts':selectedChannelTts?selectedChannelTts:[],
                        'outlet_codes':excludedOutletFromSummary?excludedOutletFromSummary:[]
                    })
                  }
                  )
                  .then(data => data.json())
                .then(data => {
                    dispatch(OutletAction.outletSummary_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.outletSummary_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.outletSummary_Failed(err.message))

            })
        }
    };

    // EXCLUDE OUTLET FILTER

    static excludeOutletFilter(
        geoData,
        channelData,
        channelName,
        selectedOutletProgram,
        selectedLocationType,
        selectedTier,
        selectedPerfectVillage,
        selectedChannelTts,
        selectedChainOutlets,
        selectedPerfectStore,
        selectedPerfectStoreCompliance,
        selectedOutleClassification,
        selectedRange,
        selectedPointOfConsumption,
        selectedLoyalityProgram,
        selectedCustomerAttribute,
        selectedOutletCodes
    ){
        return dispatch => {
            dispatch(OutletAction.excludeOutletFilter_Request());
            utils.get_token()
            .then(token => {
                fetch(
                    Path.EXCLUDE_OUTLET_FILTER,
                    {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        'distributors':geoData?geoData:[],
                        'channel_level':channelName?channelName:null,
                        'channels':channelData?channelData:[],
                        'outlet_programs':selectedOutletProgram?selectedOutletProgram:[],
                        'location_types':selectedLocationType?selectedLocationType:[],
                        'tiers':selectedTier?selectedTier:[],
                        'perfect_villages':selectedPerfectVillage?selectedPerfectVillage:[],
                        'perfect_stores':selectedPerfectStore?selectedPerfectStore:[],
                        'perfect_store_compliances':selectedPerfectStoreCompliance?selectedPerfectStoreCompliance:[],
                        'outlet_classifications':selectedOutleClassification?selectedOutleClassification:[],
                        'outlet_ranges':selectedRange?selectedRange:[],
                        'point_of_consumptions':selectedPointOfConsumption?selectedPointOfConsumption:[],
                        'loyalty_programs':selectedLoyalityProgram?selectedLoyalityProgram:[],
                        'chain_outlets':selectedChainOutlets?selectedChainOutlets:[],
                        'customer_attributes_12':selectedCustomerAttribute?selectedCustomerAttribute:[],
                        'channels_tts':selectedChannelTts?selectedChannelTts:[],
                        'outlet_codes':selectedOutletCodes?selectedOutletCodes:[]
                    })
                  }
                  )
                  .then(data => data.json())
                .then(data => {
                    dispatch(OutletAction.excludeOutletFilter_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.excludeOutletFilter_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.excludeOutletFilter_Failed(err.message))

            })
        }
    };

    // EXCLUDE OUTLET FROM SUMMARY

    static excludeOutletFromSummary(
    outletSummary,
    excludedOutlets
        ){
        return dispatch => {
            dispatch(OutletAction.excludeOutletFromSummary_Request());
            utils.get_token()
            .then(token => {
                fetch(
                    Path.EXCLUDE_FROM_SUMMARY,
                    {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        'outlet_summary':outletSummary,
                        'excluded_outlets':excludedOutlets
                    })
                  }
                  )
                  .then(data => data.json())
                .then(data => {
                    dispatch(OutletAction.excludeOutletFromSummary_Success(data))
                    // ToastsStore.success('Outlet excluded')
                    CustomToast('success', 'Outlet excluded')
                })
                .catch(err => {
                    dispatch(OutletAction.excludeOutletFromSummary_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.excludeOutletFromSummary_Failed(err.message))

            })
        }
    };

    // EXCLUDE OUTLET FOR APPROVAL SCREEN

    static getExcludeOutletForApprovalScreen(
        guid
        ){
        return dispatch => {
            dispatch(OutletAction.excludeOutletForApproval_Request());
            utils.get_token()
            .then(token => {
                fetch(
                    Path.BASE_URL+`/activity/${guid}/excluded_outlets/`,
                    {
                    method: "GET",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`
                    }
                  }
                  )
                  .then(data => data.json())
                .then(data => {
                    dispatch(OutletAction.excludeOutletForApproval_Success(data))
                })
                .catch(err => {
                    dispatch(OutletAction.excludeOutletForApproval_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(OutletAction.excludeOutletForApproval_Failed(err.message))

            })
        }
    };
}

